import { Role } from '../enums/role.enum';
import { CurrentUser } from './current-user';

export class PhysicianUser implements CurrentUser {
  email: string;

  fullName: string;

  role: Role;

  defaultUrl: string;

  number: string;

  registrationDate: Date;

  constructor(user: any) {
    this.email = user.email;
    this.role = user.role;
    this.defaultUrl = '/';
    if (user.basic) {
      this.fullName = user.firstName + ' ' + user.lastName;
    }
    this.number = user.number;
    this.registrationDate = user.registrationDate;
  }
}
